module.exports = __webpack_public_path__ + "linea-weather-10.eef9b7d7918436513bec.ttf";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-weather-10.ttf
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-weather-10.ttf
// module chunks = styles